'use strict';

angular.module('cvsApp').factory('networkRequestFactory', ['$resource','configservice','$http','PageValues',
	function ($resource,config,httpService,PageValues) {

	var appConfig = config.appConfig();
	PageValues.appConfig=appConfig;
	var header={
		'Content-Type': 'application/xml'
	};
	if(appConfig.env!="dev1" && appConfig.env!="dev2" && appConfig.env!="dev3" &&appConfig.env!="local"){
		var  httpHeader={'pragma':PageValues.pragmaHeaderValue};
		header=_.extend(header, httpHeader);
	}
	var x2js = new X2JS();
	//to change environment
	var enviornment='';
			var APP_NAME;
			var CHANNEL_NAME;
			if(!cvsUtility.isMobile()) {
				APP_NAME = 'SPL_WEB';
				CHANNEL_NAME = 'Web';
			}
			else {
				APP_NAME = 'SPL_WEB';
				CHANNEL_NAME = 'Web_MobAnd';
			}
			return {
				/*https://devservices-west.caremark.com:11103/specialty/validateDeepLink?appName=
				// SPL_WEB&channelName=Web_MobAnd&lineOfBusiness=Specialty&serviceCors=True&serviceName=validateDeepLink
				// &version=3.0
				 https://devservices-west.caremark.com:11103/specialty/deepLinking/validateLink/3.0
				 https://devservices-west.caremark.com:11103/specialty/validateDeepLink?appName=SPL_WEB&
				 channelName=Web_MobAnd&lineOfBusiness=Specialty&serviceCors=True&serviceName=validateDeepLink&version=3.0*/

				validateXID:$resource(appConfig.apiURL + '/:domain/:serviceName/:operationName/:version', {
					/*version: '3.0',
					appName:APP_NAME,
					channelName: CHANNEL_NAME,
					lineOfBusiness: 'Specialty',
					//apiKey: appConfig.apiKey,
					//apiSecret: appConfig.apiSecret,
					serviceCors:'True'*/
				}, {
					retrieveData: {
						method: 'POST',
						headers: header,
						params: {
							version:'3.0',
							serviceName: 'deepLinking',
							operationName:'validateLink',
							domain:'specialty'
						},
						transformRequest:transformRequest,
						transformResponse:transformResponse
					}

				}),
				//For testing appsettings.json uncomment the next function and comment next to next function.
				wcmConfigDetails:$resource(appConfig.apiURL+ '/:domain/:endPoint',{},{
					retrieveData:{
						method:'POST',
						headers: header,
						params:{
							endPoint:'getSpecialtyWCMContent',
							serviceName: 'getSpecialtyWCMContent',
							operationName:'getSpecialtyWCMContent',
							domain:'specialty',
							version:"2.0"
						},
						transformResponse:function(data){
							console.log(x2js.xml_str2json(data));
							return x2js.xml_str2json(data)
						}
					}
				})

			};

	function httpRequest(method, payload,timeOutTime) {
		var httpHeader;
		/*if(cvsUtility.queryMap.enableHttpTrace == "yes"){
		 httpHeader={'pragma':CVS.Config.httpHeader['pragmaHeaderValue']};
		 } else{
		 httpHeader ={};
		 }*/

		payload.header = _.extend(payload.header, httpHeader);
		var request = {
			method: method,
			url: payload.url,
			headers:payload.header,
			data: payload.data,
			timeout:timeOutTime?timeOutTime:CVS.Config.timeout.default
		};
		return httpService(request);
	}

	function transformResponse(data){
		return x2js.xml_str2json(data)
	}

	function transformRequest(data){

		/*var requestHeader={
			header:{
				apiKey: appConfig.apiKey,
				serviceContext:{
					appName:"SPL_Web",
					lineOfBusiness:"Specialty",
					serviceCors:"True",
					channelName:"Web"
				}
			}
		};
		data=_.extend(data.headersTEsted, requestHeader);*/
		return x2js.json2xml_str(data);
	}
}]);
